import Head from 'next/head';
import { AppProps } from 'next/app';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { CacheProvider, EmotionCache } from '@emotion/react';
import theme from '../src/theme/theme';
import createEmotionCache from '../src/lib/createEmotionCache';
import { Global } from '@emotion/react';
import globalStyles from '@theme/global-styles';
import Script from 'next/script';
import { GoogleAnalytics } from 'nextjs-google-analytics';

// Client-side cache, shared for the whole session of the user in the browser.
const clientSideEmotionCache = createEmotionCache();

interface MyAppProps extends AppProps {
  emotionCache?: EmotionCache;
}

export default function MyApp(props: MyAppProps) {
  const { Component, emotionCache = clientSideEmotionCache, pageProps } = props;
  return (
    <CacheProvider value={emotionCache}>
      <Head>
        <meta name="viewport" content="initial-scale=1, width=device-width" />
        <title>Your personal trading companion | walnuts.farm</title>
      </Head>
      <ThemeProvider theme={theme}>
        <Global styles={globalStyles} />
        {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
        <CssBaseline />
        <GoogleAnalytics strategy="lazyOnload" />
        <Component {...pageProps} />
      </ThemeProvider>
    </CacheProvider>
  );
}
